import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./TermsView.styles";
import { useTranslation } from "react-i18next";

import {
    WithStyles,
    withStyles,
} from "@material-ui/core";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IUsersRightsViewProps extends WithStyles<typeof styles> {}

const UsersRightsViewPure: React.FunctionComponent<IUsersRightsViewProps> = ({ classes }) => {
    const {t} = useTranslation();
    return <CenteredContainer>
        <div className={classes.title}>
            <Typography variant="h2">{t("footer.userRights.title")}</Typography>
            <Typography variant="h3">{t("footer.userRights.withdrawalTitle")}</Typography>
            <Typography variant="body1">{t("footer.userRights.withdrawalText1")}</Typography>
            <Typography variant="body1">{t("footer.userRights.withdrawalText2")}</Typography>

            <Typography variant="h3">{t("footer.userRights.effectsTitle")}</Typography>
            <Typography variant="body1">{t("footer.userRights.effectsText1")}</Typography>
            <Typography variant="body1">{t("footer.userRights.effectsText2")}</Typography>
            <Typography variant="body1">{t("footer.userRights.effectsText3")}</Typography>

            <Typography variant="h3">{t("footer.userRights.modelTitle")}</Typography>
            <Typography variant="body1">{t("footer.userRights.modelText1")}</Typography>
            <Typography variant="body1">Deutsche Börse AG<br></br>60485 Frankfurt/Main<br></br>{t("general.germany")}<br></br>{t("general.phone")}: +49-(0) 69-2 11-11 0 33<br></br>{t("general.email")}<a href="mailto:historical.data@deutsche-boerse.com" target="_self">historical.data@deutsche-boerse.com</a></Typography>
            <Typography variant="body1">{t("footer.userRights.modelText2")}</Typography>
            <Typography variant="body1">{t("footer.userRights.modelText3")}</Typography>
            <Typography variant="body1">{t("footer.userRights.modelText4")}</Typography>
            <Typography variant="body1">{t("footer.userRights.modelText5")}</Typography>
            <Typography variant="body1">{t("footer.userRights.modelText6")}</Typography>
            <Typography variant="body1">{t("general.date")}</Typography>
            <Typography variant="body2">{t("footer.userRights.modelText7")}</Typography>
        </div>
    </CenteredContainer>;
};

export const UsersRightsView = withStyles(styles)(UsersRightsViewPure);
